import { ExerciseType } from '@/utils/exerciseNames';

export type StateType = {
  term: string;
  termType: string;
  searchType: string;
  searchWordsPerPage: number;
  page: number;
  partsOfSpeech: PartsOfSpeechKey;
  basic: {
    Silbenanzahl: number[];
    Silbenstruktur: string[];
    Wortakzent: number[];
    Wortfrequenz: string[];
    Genus: string[];
    Numerus: number[];
  };
  phonemes: {
    initialSelected: string[];
    initialUnselected: string[];
    medialSelected: string[];
    medialUnselected: string[];
    finalSelected: string[];
    finalUnselected: string[];
  };
};

type PartsOfSpeechKey =
  'nomen' | 'verb' | 'adjektiv' | 'zahlenwort' | 'floskel';

export const PARTS_OF_SPEECH_KEY = {
  nomen: 'nouns',
  verb: 'verbs',
  adjektiv: 'adjectives',
  zahlenwort: 'numberWords',
  floskel: 'fillerWords',
};

interface ResetStateActionType {
  type: 'RESET_STATE';
  payload: StateType | object;
}

interface OuterStateActionType {
  type: 'OUTER_STATE';
  payload: {
    name: keyof StateType;
    value: unknown;
  };
}

interface ChangePageActionType {
  type: 'CHANGE_PAGE';
  payload: {
    arrowName: 'right' | 'left' | null;
    value: number;
  };
}

interface BasicStateActionType {
  type: 'BASIC_STATE';
  payload: {
    name: keyof StateType['basic'];
    isRemove: boolean;
    value: unknown;
  };
}

interface PhonemeRowStateActionType {
  type: 'PHONEME_ROW_STATE';
  payload: {
    name: 'initial' | 'medial' | 'final';
    isRemove: boolean;
    values: string[];
  };
}
interface PhonemeAllStateActionType {
  type: 'PHONEME_ALL_STATE';
  payload: {
    name: 'initial' | 'medial' | 'final';
    isRemove: boolean;
    values: string[];
  };
}

interface PhonemeStateType {
  type: 'PHONEME_STATE';
  payload: {
    name: 'initial' | 'medial' | 'final';
    isRemove: boolean;
    value: string;
  };
}

export type ActionType =
  | ResetStateActionType
  | OuterStateActionType
  | ChangePageActionType
  | PhonemeRowStateActionType
  | PhonemeAllStateActionType
  | PhonemeStateType
  | BasicStateActionType;

export type WordSetContextType = {
  name: string;
  appDisplayName: string;
  exerciseTypes: ExerciseType[];
  wordsetItems: {
    _id: string;
    active: boolean;
    word: any[];
    user: any;
  }[];
  _id: string;
  createdAt: string;
  updatedAt: string;
};
